import { css } from 'styled-components';

import theme from './theme';

export const LinkStyles = css`
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  color: ${theme.arrowLinkLabelColor};
`;

export const LinkContainerStyles = css`
  border-bottom: 1px solid ${Styles.color.grey.four};
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
